import {
  Inject,
  Injectable
}                       from '@angular/core';
import { OpaqueToken }	from '@angular/core';

export const BrandConfig = new OpaqueToken('BrandService');

export interface BrandConfigProtocol {
  analyticsKey:   string;
  baseUrl:        string;
  brandName:      string;
  doorbellAppID:  string;
  doorbellKey:    string;
  googleMapsKey:  string;
}

@Injectable()
export class BrandService implements BrandConfigProtocol {
	analyticsKey:		string;
	baseUrl:				string;
	brandName:			string;
	doorbellAppID:	string;
	doorbellKey:		string;
	googleMapsKey:	string;

	constructor(@Inject(BrandConfig) brandConfig: BrandConfigProtocol) {
		this.analyticsKey		= brandConfig.analyticsKey;
		this.baseUrl				= brandConfig.baseUrl;
		this.brandName			= brandConfig.brandName;
		this.doorbellAppID	= brandConfig.doorbellAppID;
		this.doorbellKey		= brandConfig.doorbellKey;
		this.googleMapsKey	= brandConfig.googleMapsKey;

    console.log('Brand service created with config :', brandConfig);
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/brand.service.ts